import {
  Activity,
  BankCard,
  HeadsetOne,
  Help,
  KeyOne,
  Logout,
  Me,
  Peoples,
  Protect,
  Rules,
  ThemeIcon,
} from "assets/Icon";
import {
  Collapse,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  useTheme,
} from "@mui/material";

import Activities from "components/SideMenuItems/Activities";
import ChangePassword from "components/SideMenuItems/ChangePassword";
import ChangeThemeButton from "components/ChangeThemeButton";
import { Link } from "react-router-dom";
import LogoutModal from "components/SideMenuItems/Logout";
import Profile from "components/SideMenuItems/Profile";
import Security from "components/SideMenuItems/Security";
import Support from "components/SideMenuItems/Support";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";

function SideMenuDrawer({ open, onClose }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isUserBlocked = useIsUserBlocked();
  const user = useSelector((state) => state.user?.user?.data);


  const [openSecurity, setOpenSecurity] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const [openListRules, setOpenListRules] = useState(false);
  const [openListHelp, setOpenListHelp] = useState(false);
  const [openThemeList, setOpenThemeList] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openActivities, setOpenActivities] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);

  const rules = {
    allRules: 5,
    exchange: 1,
    harvest: 3,
    loan: 4,
    investment: 6
  };

  const help = {
    questions: 15,
    exchange: 11,
    harvest: 13,
    loan: 14,
    investment: 16
  };

  const handleOpenListRules = () => {
    setOpenListRules(!openListRules);
  };

  const handleOpenListHelp = () => {
    setOpenListHelp(!openListHelp);
  };

  const handleOpenSecurity = () => {
    setOpenSecurity(true);
    onClose();
  };

  const handleOpenChangePassword = () => {
    setOpenChangePassword(true);
    onClose();
  };

  const handleOpenSupport = () => {
    setOpenSupport(true);
    onClose();
  };

  const handleOpenProfile = () => {
    setOpenProfile(true);
    onClose();
  };

  return (
    <>
      <DrawerStyle anchor="left" open={open} onClose={onClose}>
        <List>
          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenProfile}>
              <ListItemIcon>
                <Me color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="پروفایل" />
            </ListItemButtonStyle>
          </ListItemStyle>

          <DividerStyle />

          {!isUserBlocked && (
            <>
              <ListItemStyle>
                <ListItemButtonStyle onClick={handleOpenSecurity}>
                  <ListItemIcon>
                    <Protect color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="امنیت" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle onClick={handleOpenChangePassword}>
                  <ListItemIcon>
                    <KeyOne color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="تغییر کلمه عبور" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    navigate("/bank-accounts");
                    onClose();
                  }}
                >
                  <ListItemIcon>
                    <BankCard color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="حساب‌های بانکی" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    navigate("/referral");
                    onClose();
                  }}
                >
                  <ListItemIcon>
                    <Peoples color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="معرفی به دوستان" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    setOpenActivities(true);
                    onClose();
                  }}
                >
                  <ListItemIcon>
                    <Activity color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="فعالیت‌ها" />
                </ListItemButtonStyle>
              </ListItemStyle>
            </>
          )}
          <DividerStyle />

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenSupport}>
              <ListItemIcon>
                <HeadsetOne color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="پشتیبانی" />
            </ListItemButtonStyle>
          </ListItemStyle>

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenListRules}>
              <ListItemIcon>
                <Rules color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="قوانین" />
              {openListRules ? (
                <ion-icon name="chevron-up-outline" />
              ) : (
                <ion-icon name="chevron-down-outline" />
              )}
            </ListItemButtonStyle>
          </ListItemStyle>

          <Collapse in={openListRules} timeout="auto" unmountOnExit>
            <List component="div">
              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.allRules}`}
                onClick={onClose}
              >
                <ListItemText primary="قوانین کلی سایت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.exchange}`}
                onClick={onClose}
              >
                <ListItemText primary="مبادله" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.harvest}`}
                onClick={onClose}
              >
                <ListItemText primary="برداشت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.loan}`}
                onClick={onClose}
              >
                <ListItemText primary="وام" />
              </ListItemButtonStyleItem>

              {
                user?.isHaveViewInvestment &&
                <ListItemButtonStyleItem
                  component={Link}
                  to={`/rules/${rules.investment}`}
                  onClick={onClose}
                >
                  <ListItemText primary="سرمایه‌گذاری" />
                </ListItemButtonStyleItem>
              }
            </List>
          </Collapse>

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenListHelp}>
              <ListItemIcon>
                <Help color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="راهنما" />
              {openListHelp ? (
                <ion-icon name="chevron-up-outline" />
              ) : (
                <ion-icon name="chevron-down-outline" />
              )}
            </ListItemButtonStyle>
          </ListItemStyle>

          <Collapse in={openListHelp} timeout="auto" unmountOnExit>
            <List component="div">
              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.questions}`}
                onClick={onClose}
              >
                <ListItemText primary="سوالات متدوال" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.exchange}`}
                onClick={onClose}
              >
                <ListItemText primary="مبادله" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.harvest}`}
                onClick={onClose}
              >
                <ListItemText primary="برداشت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.loan}`}
                onClick={onClose}
              >
                <ListItemText primary="وام" />
              </ListItemButtonStyleItem>

              {
                user?.isHaveViewInvestment &&
                <ListItemButtonStyleItem
                  component={Link}
                  to={`/help/${help.investment}`}
                  onClick={onClose}
                >
                  <ListItemText primary="سرمایه‌گذاری" />
                </ListItemButtonStyleItem>
              }
            </List>
          </Collapse>


          <ListItemStyle>
            <ListItemButtonStyle onClick={() => setOpenThemeList(!openThemeList)}>
              <ListItemIcon>
                <ThemeIcon color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="تم رنگی" />
              {openListRules ? (
                <ion-icon name="chevron-up-outline" />
              ) : (
                <ion-icon name="chevron-down-outline" />
              )}
            </ListItemButtonStyle>
          </ListItemStyle>

          <Collapse in={openThemeList} timeout="auto" unmountOnExit>
            <ChangeThemeButton />
          </Collapse>

          <ListItemStyle>
            <ListItemButtonStyle
              onClick={() => {
                setOpenLogout(true);
                onClose();
              }}
            >
              <ListItemIcon>
                <Logout color={theme.palette.secondary.main} />
              </ListItemIcon>
              <ListItemText primary="خروج" sx={{ color: "secondary.main" }} />
            </ListItemButtonStyle>
          </ListItemStyle>

        </List>
      </DrawerStyle>

      {openProfile && (
        <Profile open={openProfile} onClose={() => setOpenProfile(false)} />
      )}

      {openSecurity && (
        <Security open={openSecurity} onClose={() => setOpenSecurity(false)} />
      )}

      {openChangePassword && (
        <ChangePassword
          open={openChangePassword}
          onClose={() => setOpenChangePassword(false)}
        />
      )}

      {openSupport && (
        <Support open={openSupport} onClose={() => setOpenSupport(false)} />
      )}

      {openActivities && (
        <Activities
          open={openActivities}
          onClose={() => setOpenActivities(false)}
        />
      )}

      {openLogout && (
        <LogoutModal open={openLogout} onClose={() => setOpenLogout(false)} />
      )}
    </>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
}));

const ListItemButtonStyleItem = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 6, 0.5, 0),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const ListItemButtonStyle = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 1),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const DrawerStyle = styled(Drawer)(({ theme }) => ({
  ".MuiPaper-root": {
    width: "200px",
    background: theme.palette.modules.sideMenu,
    borderTopRightRadius: "15px",
    borderBottomRightRadius: "15px",
  },
}));

const DividerStyle = styled(Divider)(({ theme }) => ({
  background: theme.palette.modules.divider,
}));

export default SideMenuDrawer;
